var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95667 0 0 8.955 0 20C0 28.8367 5.73 36.3333 13.6783 38.9783C14.6767 39.1633 15 38.5433 15 38.0167V34.2933C9.43667 35.5033 8.27833 31.9333 8.27833 31.9333C7.36833 29.6217 6.05667 29.0067 6.05667 29.0067C4.24167 27.765 6.195 27.7917 6.195 27.7917C8.20333 27.9317 9.26 29.8533 9.26 29.8533C11.0433 32.91 13.9383 32.0267 15.08 31.515C15.2583 30.2233 15.7767 29.34 16.35 28.8417C11.9083 28.3333 7.23833 26.6183 7.23833 18.9567C7.23833 16.7717 8.02 14.9883 9.29833 13.5883C9.09167 13.0833 8.40667 11.0483 9.49333 8.295C9.49333 8.295 11.1733 7.75833 14.995 10.345C16.59 9.90167 18.3 9.68 20 9.67167C21.7 9.68 23.4117 9.90167 25.01 10.345C28.8283 7.75833 30.505 8.295 30.505 8.295C31.5933 11.05 30.9083 13.085 30.7017 13.5883C31.985 14.9883 32.76 16.7733 32.76 18.9567C32.76 26.6383 28.0817 28.33 23.6283 28.825C24.345 29.445 25 30.6617 25 32.5283V38.0167C25 38.5483 25.32 39.1733 26.335 38.9767C34.2767 36.3283 40 28.8333 40 20C40 8.955 31.045 0 20 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e682378643626b9b7d928dee71ba1907.svg";
export { ForwardRef as ReactComponent };